import classes from "./separator.module.scss";
import clsx from "clsx";

import { CARD_CORRECTIONS } from "../../../utils/consts";

const isCardCorrect = (c) => {
  return (
    c.correction == CARD_CORRECTIONS.ok ||
    c.correction == CARD_CORRECTIONS.locked
  );
};

const getSeparatorStyles = (
  cardArray,
  idx,
  questionCorrect,
  isQuestionSeparator,
  className = undefined
) => {
  // Element separator
  if (className != undefined) return className; // Style Override
  if (isQuestionSeparator) return clsx(classes.separatorBig, classes.hidden); // Screen separator --> bigger, do not render line
  if (!cardArray) return clsx(classes.separator, classes.hidden); // Default separator --> list separator, do not render line

  // Answer separator (dynamic)

  if (questionCorrect) return clsx(classes.separator, classes.rightAnswer); // Question is correct, render always green

  const correct1 = isCardCorrect(cardArray[idx]);
  const correct2 = isCardCorrect(cardArray[idx + 1]);

  if (correct1 !== correct2) return clsx(classes.separator, classes.hidden); // Default size, do not render line on transition

  if (correct1 && correct2) return clsx(classes.separator, classes.hidden); // Question incorrect, answers correct, do not render line

  return clsx(classes.separator, classes.wrongAnswer); // Question and answers incorrect, render red
};

export default function Separator({
  cardArray,
  idx,
  questionCorrect,
  questionSeparator,
  className,
}) {
  return (
    <div
      className={getSeparatorStyles(
        cardArray,
        idx,
        questionCorrect,
        questionSeparator,
        className
      )}
    ></div>
  );
}
